import { isRESTAPIError } from '@gonfalon/rest-api/errors';
import { trackError } from '@gonfalon/telemetry/trackError';
import type { RUMCustomErrorContext } from '@gonfalon/telemetry/types';

import { getHTTPStatusSeverity } from './getHTTPStatusSeverity';
import { wrapRouteError } from './wrapRouteError';

export function trackRouteError(error: unknown, context: RUMCustomErrorContext = {}) {
  if (!error) {
    return;
  }

  const routeErrorContext: RUMCustomErrorContext = { ...context };

  if (isRESTAPIError(error)) {
    routeErrorContext.url = error.url;
    routeErrorContext.metadata = {
      ...routeErrorContext.metadata,
      status: error.status,
      code: error.code,
      url: error.url,
    };

    if (!routeErrorContext.severity) {
      routeErrorContext.severity = getHTTPStatusSeverity(error.status);
    }
  }

  trackError(wrapRouteError(error), routeErrorContext);
}
